module.exports = __webpack_public_path__ + "img/about-images-founders-profiles-joanna.b65da10a.webp";